import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ConfirmationConfig {
  header?: string;
  bodyHeader?: string;
  bodySubtitle?: string;
  yesButtonText?: string;
  noButtonText?: string;
  yesButtonColor?: string;
  yesBtnCss?: string
  noBtnCss?: string
  noButtonColor?: string;
  width?: string;
}

interface ConfirmationRequest {
  config: ConfirmationConfig;
  resolve: (result: boolean) => void;
}
@Injectable({
  providedIn: "root",
})
export class ConfirmService {
  private confirmationRequestSubject = new Subject<ConfirmationRequest>();
  confirmationRequest$ = this.confirmationRequestSubject.asObservable();


  confirm(config: ConfirmationConfig): Promise<boolean> {
    return new Promise((resolve) => {
      this.confirmationRequestSubject.next({ config, resolve });
    });
  }


  confirmDelete(itemName?: string): Promise<boolean> {
    return this.confirm({
      header: 'Delete Confirmation',
      bodyHeader: `Delete ${itemName || 'this item'}?`,
      bodySubtitle: 'This action cannot be undone.',
      yesButtonText: 'Delete',
      noButtonText: 'Cancel',
      yesButtonColor: '#dc2626',
      noButtonColor: '#6b7280'
    });
  }

  confirmSave(): Promise<boolean> {
    return this.confirm({
      header: 'Save Changes',
      bodyHeader: 'Do you want to save your changes?',
      bodySubtitle: 'Your changes will be permanently saved.',
      yesButtonText: 'Save',
      noButtonText: 'Cancel',
      yesButtonColor: '#10b981',
      noButtonColor: '#6b7280'
    });
  }

  confirmDiscard(): Promise<boolean> {
    return this.confirm({
      header: 'Discard Changes',
      bodyHeader: 'Are you sure you want to discard changes?',
      bodySubtitle: 'All unsaved changes will be lost.',
      yesButtonText: 'Discard',
      noButtonText: 'Keep Editing',
      yesButtonColor: '#f59e0b',
      noButtonColor: '#6b7280'
    });
  }

  confirmLogout(): Promise<boolean> {
    return this.confirm({
      header: 'Logout',
      bodyHeader: 'Are you sure you want to logout?',
      bodySubtitle: 'You will need to login again to access your account.',
      yesButtonText: 'Logout',
      noButtonText: 'Cancel',
      yesButtonColor: '#3b82f6',
      noButtonColor: '#6b7280'
    });
  }
}
